/**
 * One scope per `loadIfNeeded()` call site — the same shape as `FilterScope`,
 * and for the same reason: several Repositories need identical bounded-
 * staleness machinery, so it is one keyed mechanism rather than a
 * `loadedAtMs` field copy-pasted into nine classes.
 */
// Only the core/admin scopes live here — a feature adds its own scope when
// it introduces a `loadIfNeeded()` call site.
export const FreshnessScopes = ['books', 'games', 'suggestions', 'admin.audit', 'admin.users', 'admin.errors'] as const
export type FreshnessScope = (typeof FreshnessScopes)[number]

/**
 * How long a successful load stays worth reusing. One shared default rather
 * than a per-scope table: nothing in this app has a measured reason to
 * differ yet, and a table of eleven identical numbers is configuration
 * theatre. Split it into a per-scope value the moment one scope actually
 * needs its own.
 */
export const DEFAULT_MAX_AGE_MS = 60_000
